import { create } from 'zustand';

interface TgState {
  tgTheme: 'light' | 'dark';
  setTgTheme: (tgTheme: 'light' | 'dark') => void;
}

export const useTgStore = create<TgState>((set) => ({
  tgTheme: 'light',
  setTgTheme: (tgTheme) => set({ tgTheme })
}));
